import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {BooleanNode} from "#template/nodes/boolean/boolean-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {ValueLikeNode} from "#template/role-markers"
import {valueMarker} from "#template/role-markers"

export type BooleanValueParameters = {value: boolean}

const booleanValueDefinition: TemplateNodeDefinition<BooleanValueParameters> = {
    nodeClass: "BooleanValue",
    validation: {
        parameters: z.object({value: z.boolean()}),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class BooleanValue extends BooleanNode<BooleanValueParameters> implements ValueLikeNode<boolean> {
    get [valueMarker]() {
        return true as const
    }

    public override get definition() {
        return booleanValueDefinition
    }

    public override evaluate(_scope: GraphBuilderScope, _evaluator: NodeEvaluator): BuilderInlet<boolean | null> {
        return this.parameters.value
    }
}
